import { Help, HelpParameters, HelpPanelColor } from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { Rect } from "../../MyHelpers";
import { SlotGameInitData } from "../../SlotGameInitData";
import { ExpandingWildsBulk, ExpandingWildsBulkConfig, ExpandingWildsBulkFactory, ExpandingWildsBulkParam } from "../ExpandingWildBulk";
import { FreegamePickElement } from "../FreegameBonus/FreegamePickElement";
import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
import { ButtonColors, Panel } from "../panel/panel";
import { PickBonus, PickBonusFactory } from "../PickBonus/PickBonus";
import { PickBonusElement } from "../PickBonus/PickBonusElement";
import { PickBonusParams, PickBonusPickElementParams } from "../PickBonus/PickBonusParams";
import { RewardColor } from "../ScatterRandomAward/RewardOptionFactory";
import { SlotGameType1 } from "../SlotGameType1";

export class CrazySeven extends SlotGameType1 {

	//protected override freegameBonusFactory: FreegameBonusFactory = new CrazySevenFreegameBonusFactory();		
	//protected override panelFactory:IPanelFactory = new CrazySevenPanelFactory();
	protected override helpFactory: IHelpFactory = new CrazySevenHelpFactory();

	protected override panelColor: ButtonColors = {
		backgroundButtonColor: "linear-gradient(rgb(40,3,64),rgb(84,4,140),rgb(84,4,140),rgb(40,3,64)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
		linearColor: "linear-gradient(to left , transparent, LightPink,transparent ) 0 10 100%",
	}


	//SEND COLOR FOR RSA 
	protected override color: RewardColor =
		{
			color: "#F1F0C9",
			coloroutherStroke: "black",
			colorinnerStroke: "#9F8DF4",
		}

	//LED COLOR
	protected override ColorLed: string = "173,83,255\n";	
	constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
		super(multigameParams, initData, "CrazySeven");
		this.spinnableReelsParams.topBorderWidth = 10;
		this.spinnableReelsParams.bottomBorderWidth = 10;
	}
}
//Panel Colorized
class CrazySevenPanelFactory implements IPanelFactory {
	public CreateNewPanel(params: PanelParams): Panel {

		return new CrazySevenPanel(params);
	}
}

class CrazySevenPanel extends Panel {
	// protected override ButtonBackground():ButtonColors
	// {
	// 	let color:ButtonColors ={
	// 		backgroundButtonColor: "linear-gradient(rgb(28, 3, 38),rgb(115, 6, 77), rgb(217, 108, 159),rgb(115, 6, 77),rgb(28, 3, 38)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
	// 		linearColor:"linear-gradient(to left , transparent, LightPink,transparent ) 0 10 100%",
	// 	};

	// 	return color;
	// }
}

class CrazySevenHelpFactory implements IHelpFactory {
	public CreateNewHelp(params: HelpParameters): Help {
		return new CrazySevenHelp(params);
	}
}

class CrazySevenHelp extends Help {
	protected override BackgroundPanel(): HelpPanelColor {
		let color: HelpPanelColor = {
			backgroundPanelColor: "linear-gradient(rgb(40,3,64),rgb(84,4,140),rgb(84,4,140),rgb(40,3,64)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
		};

		return color;
	}
}